const initialState = {
  logoutByManager: false,
}
export default function manageControlReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_LOGOUT_BY_MANAGER':
      return {
        ...state,
        logoutByManager: true,
      }
    case 'RESET_LOGOUT_BY_MANAGER':
      return {
        ...state,
        logoutByManager: false,
      }     
      
    default:
      return state
  }
}
